import _ from 'lodash';

import availableLanguages from '../i18n/available-languages';
import getDefaultLocale from '../../misc/getDefaultLocale';
import langNames from '../i18n/lang-names';
import loadTranslation from '../../misc/loadTranslation';

export default function (state, action) {
    if (!state) {
        let defaultLocale = getDefaultLocale() || 'en';
        state = {
            locale: defaultLocale,
            translations: loadTranslation(defaultLocale),
            availableLanguages,
            langNames,
        };
    }

    let locale = action.locale || state.locale;
    switch (action.type) {
        case 'I18N_LOAD_DEFAULT_LANGUAGE':
            locale = getDefaultLocale() || locale;
        // do not break here: next action is important!
        case 'I18N_LOAD_LANGUAGE':
            if (_(state.availableLanguages).includes(locale)) {
                state = Object.assign({}, state, {
                    locale: locale,
                    translations: loadTranslation(locale),
                });
            }
            break;
    }

    return state;
}
